module.exports = "precision highp float;\nvarying vec2 vUv;\nuniform vec2 size;\n\n\nvoid main() {\n    vUv = uv;\n\n    float offX = (1.- size.x) * 0.5;\n    float offY = (1.- size.y) * 0.9;\n\n    vUv *= size;\n    vUv.x += offX;\n    vUv.y += offY;\n\n    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}"


//////////////////
// WEBPACK FOOTER
// ./mysite/resources/shaders/plain.vert
// module id = ./mysite/resources/shaders/plain.vert
// module chunks = main